// extracted by mini-css-extract-plugin
export default {"StopwatchDisplay":"StopwatchDisplay_StopwatchDisplay__3Ccj3","timers":"StopwatchDisplay_timers__gkbrM","timers__second":"StopwatchDisplay_timers__second__BhMle"};